import React from 'react';
import BaseClass from '@/pages/BaseClass';

import $ from 'jquery';
import {
	Button,
	Input,
	Form,
	Select,
	Steps,
	Upload,
	Row,
	Col,
	Image,
} from 'antd'
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost
} from '@/utils/Tools';

const {Option} = Select;
export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'feedbackType':0,
			'complainTypeList':{},
			'rules':{
				
			},
			
			'fileList':[],
			'preview':{
				'visible':false,
				'src':'',
			},
		};
	}
	
	componentDidMount()
	{
		this.mainForm.setFieldsValue({
			'feedback_type':0,
			'attachment':[],
		});
		this.initContent();
		this.getComplainTypeList();
		document.title = '投诉建议 - ' + CommonValue.get('site_name');
	}
	
	initContent()
	{
		if(!this.mainForm) return ;
		
		let feedbackType = this.mainForm.getFieldValue('feedback_type');
		if(0 == feedbackType)
		{
			let content = '【需求场景】\n\n\n\n\n【改进意见】';
			this.mainForm.setFieldsValue({
				'content':content,
			});
			let rules = {};
			rules['feedback_title'] = [
				{
					required: true,
					message: '请输入标题内容',
				},
			];
			rules['content'] = [
				{
					required: true,
					message: '请输入建议内容',
				},
			];
			this.setState({
				'rules':rules,
			});
		}
		else if(1 == feedbackType)
		{
			let content = '';
			this.mainForm.setFieldsValue({
				'content':content,
			});
			
			let rules = {};
			rules['complain_type'] = [
				{
					required: true,
					message: '请选择投诉类型',
				},
			];
			rules['contact_name'] = [
				{
					required: true,
					message: '请输入联系人姓名',
				},
			];
			rules['phone'] = [
				{
					required: true,
					message: '请输入手机号',
				},
				{
					pattern: /^1\d\d\d{8}$/,
					message: '请输入正确的手机号',
				},
			];
			rules['content'] = [
				{
					required: true,
					message: '请输入投诉内容',
				},
			];
			this.setState({
				'rules':rules,
			});
		}
	}
	
	getComplainTypeList()
	{
		let url = pcUrl('feedback','complainTypeList');
		
		httpPost(url)
			.then(data=>{
				this.setState({
					'complainTypeList':data,
				});
			});
	}
	
	handleRemoveImage(file)
	{
		return new Promise((resolve,reject)=>{
			confirm('确认要删除该图片吗?')
				.then(()=>{
					let url = pcUrl('user','deleteFile');
					let param = {
						'file':[
							file.thumbUrl,
							file.url,
						].join(','),
					};
					httpPost(url,param)
						.then(()=>{
							resolve();
						});
				})
				.catch(()=>{
					reject();
				});
		});
	}
	handlePreviewImage(file)
	{
		this.setState({
			'preview':{
				'visible':true,
				'src':file.url,
			},
		});
	}
	
	handleUploadChange(data)
	{
		if(data.fileList.length)
		{
			data.fileList.forEach((row,index)=>{
				if(row.response)
				{
					let response = row.response;
					if(response.code != 0)
					{
						message(response.message);
						return;
					}
					
					data.fileList[index] = {
						'uid':index+1,
						'name':'',
						'status':'done',
						'thumbUrl':response.data,
						'url':response.data.replace('thumb.',''),
					};
				}
			});
			data.fileList = data.fileList.filter(row=>{
				if(row.response && row.response.code != 0)
					return false;
				else
					return true;
			});
		}
		this.mainForm.setFieldsValue({
			'attachment':data.fileList,
		});
		/*
		if(data.file)
		{
			//if(data.file.status == 'removed')
			if(1)
			{
			}
		}
		*/
	}
	
	submit(data)
	{
		confirm('您的填写无误并确定要提交吗?')
			.then(()=>{
				let url = pcUrl('feedback','add');
				let param = data;
				param['attachment'] = param['attachment'].map(row=>{
					return row['thumbUrl'];
				}).join(',');
				
				httpPost(url,param)
					.then(()=>{
						if(param['feedback_type'] == 0)
						{
							message('感谢您对我们的支持，我们会根据您反馈的宝贵建议来改进自己，提供更好服务','success');
							this.mainForm && this.mainForm.resetFields();
							this.mainForm && this.mainForm.setFieldsValue({
								'feedback_type':0,
								'attachment':[],
							});
							this.initContent();
						}
						else if(param['feedback_type'] == 1)
						{
							message('感谢您对我们的支持，您的投诉内容我们会在2个工作日与您取得联系','success');
							this.mainForm && this.mainForm.resetFields();
							this.mainForm && this.mainForm.setFieldsValue({
								'feedback_type':1,
								'attachment':[],
							});
							this.initContent();
						}
					});
			});
	}
	
	render()
	{
		return (
			<div style={{'padding-left':'1em'}}>
				<div className="user-panel">
					<div className="captain">
						<h3>投诉建议</h3>
					</div>
					<div className="panel-body">
						<Form
							ref={e=>this.mainForm = e}
							onFinish={(data)=>this.submit(data)}
							onFinishFailed={data=>this.focusError(data)}
							labelCol={{ span:4 }}
							wrapperCol={{ span:15 }}>
							<Form.Item noStyle shouldUpdate>
								{()=>(
									<>
										<Form.Item name="feedback_type" label="请选择提交类型">
											<Row gutter={10}>
												<Col span={12}>
													<div className={['form-button-area',(this.mainForm && this.mainForm.getFieldValue('feedback_type') == 0 ? 'now':'')].join(' ')} onClick={()=>{this.mainForm && this.mainForm.setFieldsValue({'feedback_type':0});this.initContent();}}>
														<strong>提建议</strong>
														请输入您对我的改进建议或体验类问题
													</div>
												</Col>
												<Col span={12}>
													<div className={['form-button-area',(this.mainForm && this.mainForm.getFieldValue('feedback_type') == 1 ? 'now':'')].join(' ')} onClick={()=>{this.mainForm && this.mainForm.setFieldsValue({'feedback_type':1});this.initContent();}}>
														<strong>我要投诉</strong>
														为了便于投诉及时得到处理，请根据真实情况准确提供以下信息
													</div>
												</Col>
											</Row>
										</Form.Item>
										
										{this.mainForm && this.mainForm.getFieldValue('feedback_type') == 0 && (
											<>
												<Form.Item name="feedback_title" label="标题内容" rules={this.state.rules['feedback_title']}>
													<Input placeholder="请输入标题内容（50字以内）" showCount maxLength={50}/>
												</Form.Item>
												<Form.Item name="content" label="内容" rules={this.state.rules['content']}>
													<Input.TextArea rows={10} placeholder="请输入建议内容"/>
												</Form.Item>
											</>
										)}
										
										{this.mainForm && this.mainForm.getFieldValue('feedback_type') == 1 && (
											<>
												<Form.Item name="complain_type" label="投诉类型" rules={this.state.rules['complain_type']}>
													<Select placeholder="请选择">
														{Object.keys(this.state.complainTypeList).map(key=>(
															<Option value={key}>{this.state.complainTypeList[key]}</Option>
														))}
													</Select>
												</Form.Item>
												<Form.Item name="contact_name" label="联系人" rules={this.state.rules['contact_name']}>
													<Input />
												</Form.Item>
												<Form.Item name="phone" label="手机号" rules={this.state.rules['phone']}>
													<Input />
												</Form.Item>
												<Form.Item name="content" label="投诉内容" rules={this.state.rules['content']}>
													<Input.TextArea rows={5} placeholder="请输入问题描述"/>
												</Form.Item>
											</>
										)}
										
										<Form.Item name="attachment" label="图片材料" rules={this.state.rules['attachment']}>
											<Upload
												action={pcUrl('index','upload')}
												showUploadList={true}
												onRemove={file=>this.handleRemoveImage(file)}
												onChange={data=>this.handleUploadChange(data)}
												onPreview={file=>this.handlePreviewImage(file)}
												fileList={this.mainForm && this.mainForm.getFieldValue('attachment')}
												data={{'thumb_size':'500,500'}}
												listType="picture-card">
													{this.mainForm && this.mainForm.getFieldValue('attachment') && this.mainForm.getFieldValue('attachment').length < 5 ?(
													<div>
														{/*
														<Button style={{'width':'8em'}}>
															点击上传
														</Button>
														*/}
														<span style={{fontSize:'20px'}}>+</span>
														<br/>
														上传图片
													</div>
													):''}
											</Upload>
											<p>
												支持选择五个文件，允许的文件类型：jpg，gif，jpeg，且不超过10MB
											</p>
											<Image preview={{...this.state.preview,'onVisibleChange':val=>{let preview = this.state.preview; preview.visible = val; this.setState({'preview':{...preview}});}}} />
										</Form.Item>
										
										{this.mainForm && this.mainForm.getFieldValue('feedback_type') == 0 && (
										<>
											<Form.Item shouldUpdate wrapperCol={{ offset:4 }}>
												<Button type="primary" htmlType="submit" style={{'width':'8em','height':'36px'}}>提交建议</Button>
											</Form.Item>
										</>
										)}
										{this.mainForm && this.mainForm.getFieldValue('feedback_type') == 1 && (
										<>
											<Form.Item shouldUpdate wrapperCol={{ offset:4 }}>
												<div style={{'font-size':'12px','color':'#999','margin-bottom':'1.5em'}}>
													<p>
													1.为保证合理诉求得到及时满足，请填写真实姓名和有效的联系方式。
													</p>
													<p>
													2.为便于投诉及时得到处理，请根据真实情况准确提供以下信息，包括但不限于产品名称、发生经过、诉求问题、订单号、账号登信息。
													</p>
													<p>
													3.我们收到投诉后，会在2个工作日与您电话沟通取得联系。如遇紧急情况，请直接联系在线客服。
													</p>
												</div>
												<Button type="primary" htmlType="submit" style={{'width':'8em','height':'36px'}}>提交投诉</Button>
											</Form.Item>
										</>
										)}
									</>
								)}
							</Form.Item>
						</Form>
					</div>
				</div>
			</div>
		);
	}
}

